export default "__VITE_ASSET__D46zo35S__"